import React, { ComponentState, useEffect, useState } from "react";
import { AppInput } from "../../../../../components/Input";
import { ErrorConsts } from "../../../../../utils/ErrorCons";
import { AppButtons } from "../../../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import { DropDownList, Upload } from "@progress/kendo-react-all";
import { Error } from "@progress/kendo-react-labels";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FormControl, MenuItem, TextField } from "@mui/material";

import "../../../../../../src/theme/global.css"
import { loaderAction } from "../../../../../redux/actions";
import { messages } from "../../../../../services/messageService";
import { MessageItem } from "../../../../../dataModel/messagesModal";

export interface MessageComposeProps {
  onClose(): void;
  title: string;
  selectedMessage?: MessageItem
  tabId: number
}

export const MessageCompose = (props: MessageComposeProps) => {
  const [buttonPressed, setButtonPressed] = useState(false);
  const [subject, setSubject] = useState<string>();
  const [bodyHtml, setBodyHtml] = useState("");
  const [body, setBody] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [uploadError, setUploadError] = useState(false);
  const [staffDDL, setStaffDDL] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState<any>(null);
  const [selectedStaffName, setSelectedStaffName] = useState<any>(null);
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const { loadingState } = state["LoaderReducer"];

  const dispatch = useDispatch();

  const handleButtonPressed = async () => {
    setButtonPressed(true)
    if (!selectedStaff || !subject || (!body || !bodyHtml)) {
      return
    }

    const data = {
      toStaffIds: [selectedStaff],
      subject: subject,
      body: body,
      htmlBody: bodyHtml,
      messageAttachments: attachments.length > 0 ? attachments.map((file: any) => file.getRawFile()) : null,
    };
    try {
      dispatch(loaderAction(true))
      const result = await messages.insertMessage(data);
      if (result) { props.onClose() }
      dispatch(loaderAction(false))
    } catch (error) {
      console.log('Error sending message:', error);
    }
  };

  const handleClose = () => {
    props.onClose();
  };

  function onBodyChange(props: any) {
    setBody(props.value.textContent);
    setBodyHtml(props.html);
  }

  function renderKendoEditor() {
    const {
      Bold,
      Italic,
      Underline,
      AlignLeft,
      AlignRight,
      AlignCenter,
      Indent,
      Outdent,
      OrderedList,
      UnorderedList,
      Undo,
      Redo,
      Link,
      Unlink,
    } = EditorTools;
    return (
      <Editor
        value={bodyHtml}
        onChange={onBodyChange}
        tools={[
          [Bold, Italic, Underline],
          [Undo, Redo],
          [Link, Unlink],
          [AlignLeft, AlignCenter, AlignRight],
          [OrderedList, UnorderedList, Indent, Outdent],
        ]}
        contentStyle={{
          height: 140,
        }}
        defaultContent={""}
      />
    );
  }

  const onAdd = (event: any) => {
    setAttachments(event.newState);
    setUploadError(false);
  };

  const onRemove = (event: any) => {
    setAttachments(event.newState);
  };

  const onStatusChange = (event: any) => {
    setAttachments(event.newState);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await messages.getClientAssignedStaffDDL(true);
        const formattedStaff = response.resultData.map((item: any) => ({
          staffId: item.staffId,
          staffName: item.staffName,
        }));
        setStaffDDL(formattedStaff);
      } catch (error) {
        console.error(error);
      }
    };
    if (staffDDL.length < 1 && !props.selectedMessage) { fetchData() };

    if (props.selectedMessage) {
      
      if (props.tabId === 0) {
        setSelectedStaff(props.selectedMessage.fromStaffId);
        setSelectedStaffName(props.selectedMessage.fromStaffName)
      } else if (props.tabId === 1) {
        setSelectedStaff(props.selectedMessage.toStaffId);
        setSelectedStaffName(props.selectedMessage.toStaffName)
      }
    }
  }, []);

  const handleStaffChange = (event: any) => {
    setSelectedStaff(event.target.value);
  };


  return (
    <>
      <div className="modal-wrapper">
        <div className="message-modal my-3">
          <button className="close-btn" onClick={handleClose}>
            <i className="fa-regular fa-circle-xmark"></i>
          </button>
          <h2 className="mb-1 fw-600">{props.title}</h2>
          <form>
            <FormControl style={{width:'100%'}}>
              <label>To</label>
              {(!props.selectedMessage) ? 
              <Select
                value={selectedStaff}
                onChange={handleStaffChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                className="message-width"
                style={{width:'100%'}}
              >
                {staffDDL.map((staff: any) => (
                  <MenuItem key={staff.staffId} value={staff.staffId}>
                    {staff?.staffName}
                  </MenuItem>
                ))}
              </Select> :
                <label
                  className={ "form-control"}>{selectedStaffName}</label>
              }
              {(buttonPressed && (!selectedStaff || selectedStaff.length < 1)) &&
                <div className="error-text">
                  {'Select a recipient'}
                </div>
              }
            </FormControl>


            <AppInput
              labelText="Subject"
              onChange={setSubject}
              placeHolder="Enter Subject"
              showError={buttonPressed && (!subject || subject.length < 1)}
              errorMessage={ErrorConsts.MESSAGE_SUBJECT}
            />
            {renderKendoEditor()}
            {(buttonPressed && (!body || body.length < 1)) &&
              <div className="error-text">
                {'Message body is required'}
              </div>
            }
            <div className="footer-composer mt-3">
              <span className="position-relative">
                <Upload
                  batch={false}
                  multiple={true}
                  autoUpload={false}
                  files={attachments}
                  defaultFiles={attachments}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  onStatusChange={onStatusChange}
                  withCredentials={false}
                  showActionButtons={false}
                  ariaDescribedBy={"firstNameError"}
                />
                {uploadError && <Error>Document is required</Error>}
              </span>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <AppButtons
                buttonText="Send"
                className="mt-3 btn-common btn-green"
                onclick={handleButtonPressed}
                loadingState={loadingState}
              ></AppButtons>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
